import React, { useMemo, useState } from "react";

import { UserIconPostLoginDefault } from "../../../SVG/UserIconPostLoginDefault";
import UserIconPostLoginMRG from "../../../SVG/UserIconPostLoginMRG/UserIconPostLoginMRG";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../../../redux/selectors";
import { LocalizationMessages } from "../../../../localization/messages";
import { FormattedMessage } from "react-intl";
import { MyAccountTab } from "../../../../constants";
import { useAccountCommunicationHandlers } from "../../../../hooks";
import {
  GreetingBoxWrapper,
  GreetingBoxDetails,
  GreetingBoxTitle,
  GreetingBoxValue,
  Avatar
} from "./greetingBoxWrapper";
import MyAccountAreaSection from "../MyAccountAreaSection/MyAccountAreaSection";
import { TrackingUtils } from "../../../../utils";
import { useTheme } from "styled-components";
import PropTypes from "prop-types";
import Arrow from "../../../common/Arrow/Arrow";
import { UserIconPostLoginVIP } from "../../../SVG/UserIconPostLoginVIP";
import { ThemeUtils } from "../../../../utils";

const GreetingBox = props => {
  const { trackingInfo } = props;
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const firstName = useSelector(UserContextSelectors.firstName);
  const cid = useSelector(UserContextSelectors.cid);
  const isVip = useSelector(UserContextSelectors.isVip);
  const { openMyAccount } = useAccountCommunicationHandlers();
  const theme = useTheme();

  const [color, setColor] = useState(theme.colors.textColor);

  const openAccountDetails = () => {
    TrackingUtils.sendAnalytics({
      dataCategory: trackingInfo.dataCategory,
      dataAction: "click",
      dataLabel: "User personal details",
      dataValue: ""
    });
    openMyAccount({ tabId: MyAccountTab.PersonalDetails });
  };

  const ProfileComponent = useMemo(() => {
    let cmp;
    if (isVip) {
      cmp = UserIconPostLoginVIP;
    } else if (ThemeUtils.isMrGreenTheme()) {
      cmp = UserIconPostLoginMRG;
    } else {
      cmp = UserIconPostLoginDefault;
    }
    return cmp;
  }, [isVip]);

  return (
    <>
      <Avatar>
        {isMobile && <ProfileComponent className="greeting-box-avatar" />}
      </Avatar>

      <MyAccountAreaSection
        handleOnClick={openAccountDetails}
        dataTestId="uc-greeting-box"
      >
        <GreetingBoxWrapper
          onMouseEnter={() => setColor(theme.colors.hooverLinkColors)}
          onMouseLeave={() => setColor(theme.colors.textColor)}
        >
          <GreetingBoxDetails>
            <GreetingBoxTitle color={color}>{firstName}</GreetingBoxTitle>
            <GreetingBoxValue>
              <FormattedMessage {...LocalizationMessages.supportId} /> {cid}
            </GreetingBoxValue>
          </GreetingBoxDetails>
          <Arrow direction="right" color={color} />
        </GreetingBoxWrapper>
      </MyAccountAreaSection>
    </>
  );
};

GreetingBox.propTypes = {
  trackingInfo: PropTypes.object
};
export default React.memo(GreetingBox);
